require('../../modules/es.object.set-prototype-of');
var path = require('../../internals/path');

module.exports = path.Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/object/set-prototype-of.js
// module id = 1002
// module chunks = 0